<form
  *ngIf="pageLoaded; else loading"
  (ngSubmit)="confirmDelete()"
  [formGroup]="deactivationFormGroup"
>
  <h2 mat-dialog-title>{{ title }}</h2>
  <div *ngIf="promoteDowngrade" class="downgrade-savings-container">
    <mat-icon class="order-warning-icon">info_outline</mat-icon>
    <div>{{ downgradeSavings }}</div>
  </div>
  <mat-dialog-content class="alert-container">
    <p>{{ deactivationReasonMsg }}</p>
    <div formArrayName="deactivationReasonFormArray">
      <div
        *ngFor="
          let reasonControl of deactivationReasonFormArray.controls;
          let i = index
        "
      >
        <mat-checkbox [formControl]="reasonControl" color="primary">
          {{ reasons[i] }}
        </mat-checkbox>
      </div>
    </div>
    <mat-form-field class="additional-info-input" appearance="outline">
      <mat-label>Additional Information</mat-label>
      <textarea
        [formControl]="additionalInformationFormControl"
        matInput
        matTextareaAutosize
        matAutosizeMinRows="1"
        maxlength="300"
      ></textarea>
      <mat-hint align="end">
        {{ additionalInformationFormControl.value.length }} / 300
      </mat-hint>
    </mat-form-field>
    <p class="warning-color warning-text" *ngFor="let warning of warnings">
      <mat-icon class="order-warning-icon">info_outline</mat-icon>
      <span>{{ warning }}</span>
    </p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="button" mat-button color="primary" matDialogClose>
      Keep product
    </button>
    <button
      class="downgrade-button"
      *ngIf="promoteDowngrade"
      type="button"
      mat-raised-button
      (click)="downgradeProduct()"
    >
      Downgrade product
    </button>
    <button mat-raised-button color="warn">Cancel product</button>
  </mat-dialog-actions>
</form>

<ng-template #loading>
  <div class="loading-spinner">
    <mat-spinner [diameter]="80"></mat-spinner>
  </div>
</ng-template>
